export const LABELS_CHIPS_LABELS = {
	POPUP_TITLE: 'Labels',
	CLOSE_BUTTON: 'Close'
};
